import { BaseService } from '@partful/shared/api/baseService';
import { Animation } from '../model/animation';

export class AnimationsService extends BaseService {
  async get(account: string, stepId: string): Promise<Animation> {
    const res = await this.client.get(`/instructions/steps/${stepId}/animations`, {
      params: { account },
    });
    return res.data;
  }

  async save(account: string, stepId: string, animation: Animation): Promise<void> {
    await this.client.put(`/instructions/steps/${stepId}/animations`, animation, { params: { account } });
  }
}
